<script setup>
import { INVITE_TYPES } from '../../domain/invitations.js';
import DateField from '../DateField.vue';

/* Die Felder einer Einladung — für das Anlegen (Entwurf) und das Bearbeiten
   (bestehender Eintrag) gleichermaßen, analog VisaFields.vue. Das Objekt wird
   direkt geändert; periodMode wird nicht hier, sondern von der aufrufenden
   Stelle über periodModeFor() neu berechnet, wenn der Zeitraum sich geändert
   haben könnte (Absenden bzw. Verlassen des Bearbeiten-Modus). */
defineProps({
  invitation: { type: Object, required: true },
});
</script>

<template>
  <div class="if-fields">
    <label class="field-inline">
      <span>{{ $t('documents.inviteTypeLabel') }}</span>
      <select v-model="invitation.type">
        <option v-for="tp in INVITE_TYPES" :key="tp" :value="tp">
          {{ $t(`documents.inviteType.${tp}`) }}
        </option>
      </select>
    </label>
    <input
      v-model="invitation.label"
      type="text"
      :placeholder="$t('documents.invitePlaceholder')"
    />
    <div class="period-fields">
      <label class="field-inline">
        <span>{{ $t('documents.invitePeriodFrom') }}</span>
        <DateField v-model="invitation.from" />
      </label>
      <label class="field-inline">
        <span>{{ $t('documents.invitePeriodUntil') }}</span>
        <DateField v-model="invitation.until" />
      </label>
    </div>
  </div>
</template>

<style scoped>
.if-fields {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.period-fields {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.period-fields .field-inline {
  flex: 1 1 140px;
}
</style>
